import api from './api'
import type { LegAssignment, LegLog } from '../types/index'

export const legService = {
  async getLegs(): Promise<LegAssignment[]> {
    const response = await api.get('/legs')
    return response.data
  },

  async getLegLogs(): Promise<LegLog[]> {
    const response = await api.get('/legs/logs')
    return response.data
  },

  async createLeg(data: Omit<LegAssignment, 'id' | 'createdAt' | 'updatedAt'>): Promise<LegAssignment> {
    const response = await api.post('/legs', data)
    return response.data
  },

  async updateLeg(id: number, data: Partial<LegAssignment>): Promise<LegAssignment> {
    const response = await api.put(`/legs/${id}`, data)
    return response.data
  },

  async createLegLog(data: Omit<LegLog, 'id' | 'createdAt' | 'updatedAt'>): Promise<LegLog> {
    const response = await api.post('/legs/logs', data)
    return response.data
  },

  async updateLegLog(id: number, data: Partial<LegLog>): Promise<LegLog> {
    const response = await api.put(`/legs/logs/${id}`, data)
    return response.data
  },

  async deleteLegLog(id: number): Promise<void> {
    await api.delete(`/legs/logs/${id}`)
  },
}
